import { sendGA4Event } from "analytics/ga4-helper";
import {
  onCLS, onFID, onINP, onLCP,
} from "web-vitals/attribution";

/**
 * References
 * https://web.dev/vitals-ga4/
 * https://web.dev/debug-web-vitals-in-the-field/
 * https://web.dev/lab-and-field-data-differences/
 * https://www.smashingmagazine.com/2021/05/core-web-vitals-case-study/
 */

function sendToGoogleAnalytics({
  name, delta, value, id, attribution,
}) {
  const eventParams = {
    // Built-in params:
    value: delta, // Use `delta` so the value can be summed.
    // Custom params:
    metric_id: id, // Needed to aggregate events.
    metric_value: value, // Optional.
    metric_delta: delta, // Optional.
  };
  switch (name) {
  case "CLS":
    eventParams.debug_target = attribution.largestShiftTarget;
    break;
  case "FID":
    eventParams.debug_target = attribution.eventTarget;
    break;
  case "LCP":
    eventParams.debug_target = attribution.element;
    break;
  case "INP":
    eventParams.debug_target = attribution.eventTarget;
    eventParams.inp_target = attribution.eventTarget;
    eventParams.inp_type = attribution.eventType;
    eventParams.inp_time = attribution.eventTime;
    eventParams.inp_load_state = attribution.loadState;
    break;
  default:
  }

  // Assumes the global `gtag()` function exists, see:
  // https://developers.google.com/analytics/devguides/collection/ga4
  sendGA4Event(name, eventParams);
}

function measureWebVitals() {
  onCLS(sendToGoogleAnalytics);
  onLCP(sendToGoogleAnalytics);
  onFID(sendToGoogleAnalytics);
  onINP(sendToGoogleAnalytics);
}

export default measureWebVitals;
